import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import CodeIcon from '@mui/icons-material/Code';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        <a href="mailto:duttameghali401@gmail.com" target="_blank" rel="noreferrer" title="Email"><EmailIcon/></a>
        <a href="tel:+918013056758" target="_blank" rel="noreferrer" title="Phone"><PhoneIcon/></a>
        <a href="https://linkedin.com/in/meghali-dutta" target="_blank" rel="noreferrer" title="LinkedIn"><LinkedInIcon/></a>
        <a href="https://github.com/Meghali54" target="_blank" rel="noreferrer" title="GitHub"><GitHubIcon/></a>
        <a href="https://leetcode.com/u/hackerslife/" target="_blank" rel="noreferrer" title="LeetCode"><CodeIcon/></a>
      </div>
      <p>A portfolio designed & built by <a href="https://github.com/Meghali54/react-portfolio-template" target="_blank" rel="noreferrer">Meghali Dutta</a> with 💜</p>
    </footer>
  );
}

export default Footer;